const extrasPriority = {
  increment_for_short_duration_pickup: 1,
  DAY_SATURDAY: 2,
  DAY_SUNDAY: 3,
  NIGHT: 4,
  LOADED_FOR_TOO_LONG: 4,
  HANDLING_LOADING: 5,
  HANDLING_UNLOADING: 6,
  DISCOUNT_PICKUP_AT_LOW_DEMAND_INTERVAL: 7,
};

const sortExtrasByPriority =
  (priority = extrasPriority) =>
  (a, b) => {
    const aValue = priority[a.concept] ? priority[a.concept] : 999;
    const bValue = priority[b.concept] ? priority[b.concept] : 999;
    return aValue - bValue;
  };

export default sortExtrasByPriority;
